import { Box } from '@mui/material';
import { FormElement } from '@uplift/types';
import { Button } from '@uplift/ui-v2';
import React from 'react';
import { useFooterStyles } from '../layout';
import clsx from 'clsx';

export type PageProps = {
  element: FormElement;
  onClick: (value?: string) => void;
};

export const Page: React.VFC<PageProps> = ({ element, onClick }) => {
  const handleChange = (name: string, value: string) => {
    onClick?.(value);
  };

  const pageButtons = element.formElementAnswers.filter(x => x.placement !== 'footer');

  return (
    <Box display="flex" flexDirection="column" gap="1.5rem">
      {pageButtons.map(answer => {
        const href = answer.linkLocation ?? answer.hintText;

        if (href) {
          return (
            <Button
              key={`button-page-${answer.formElementAnswerId}`}
              color="secondary"
              variant={answer.answerType === 'outlined' ? 'outlined' : 'contained'}
              fullWidth
              component="a"
              href={href}
              target="_blank"
            >
              {answer.answerText}
            </Button>
          );
        }

        return (
          <Button
            key={`button-page-${answer.formElementAnswerId}`}
            color="secondary"
            variant={answer.answerType === 'outlined' ? 'outlined' : 'contained'}
            fullWidth
            onClick={() => handleChange(element.formElementId, answer.formElementAnswerId)}
          >
            {answer.answerText}
          </Button>
        );
      })}
    </Box>
  );
};

export const ReplacedFooter: React.VFC<PageProps> = ({ element, onClick }) => {
  const { classes } = useFooterStyles();
  const footerButtons = element.formElementAnswers.filter(x => x.placement === 'footer');
  const handleChange = (name: string, value: string) => {
    onClick?.(value);
  };

  return (
    <Box className={clsx(classes.footer, classes.footerBorder)}>
      <Box className={classes.replacedFooter} display="flex" flexDirection="column" gap=".5rem">
        {footerButtons.map(answer => {
          const href = answer.linkLocation ?? answer.hintText;

          if (href) {
            return (
              <Button
                key={`button-page-${answer.formElementAnswerId}`}
                color="secondary"
                variant={answer.answerText === 'outlined' ? 'outlined' : 'contained'}
                fullWidth
                component="a"
                href={href}
                target={answer.newWindow ? '_blank' : undefined}
              >
                {answer.answerText}
              </Button>
            );
          }

          return (
            <Button
              key={`button-page-${answer.formElementAnswerId}`}
              color="secondary"
              variant={answer.answerType === 'outlined' ? 'outlined' : 'contained'}
              fullWidth
              onClick={() => handleChange(element.formElementId, answer.formElementAnswerId)}
            >
              {answer.answerText}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};
